/* eslint-disable @next/next/no-img-element */
import InstantArticle from "views/articles/InstantArticle"
import BestAudioApps from "views/articles/BestAudioApps"
import Link from "next/link"
import { AppInterface } from "types/types"
import AppsListItem from "components/AppsListItem"

const BestAudioAppsArticle = ({ apps }: { apps: AppInterface[] }) => {
  const article = BestAudioApps["en"]
  return (
    <InstantArticle {...article}>
      <div dir="ltr" style={{ textAlign: "justify" }}>
        <p>
          Looking for the best audio trimmer and editor apps for your iPhone or
          iPad? Here, we&apos;ve compiled a list of the top 4 apps, each with
          its own unique features to cater to all your audio editing needs. From
          converting m4a to mp3, youtube to wav, and mp3 to wave, these apps
          have you covered. So, let&apos;s dive in and find the perfect app for
          you!
        </p>

        <h2>Lexis Audio Editor</h2>
        <p>
          Lexis Audio Editor is a versatile audio trimmer and merger app for iOS
          devices. This powerful tool offers an easy-to-use interface for
          trimming, compressing, and merging audio files, making it perfect for
          both beginners and advanced users alike.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 1259401721)} />
        </div>

        <h2>Hokusai Audio Editor</h2>
        <p>
          Hokusai Audio Editor is an intuitive app for editing and trimming
          audio files on the go. With its vocal remover feature, you can create
          karaoke tracks from your favorite songs or remove unwanted background
          noise from your recordings.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 432079746)} />
        </div>

        <h2>The Audio Converter</h2>
        <p>
          This app specializes in converting m4a to mp3 and is an essential tool
          for those who need to switch between audio formats. Its user-friendly
          interface and quick conversion process make it a favorite among iPhone
          and iPad users.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 889643660)} />
        </div>

        <h2>Audio Trimmer - Trim Audio</h2>
        <p>
          Audio Trimmer is a powerful audio editor and trimmer app that helps
          you optimize your audio files for sharing or storage. With its simple
          interface, you can easily trim your audio files and save the exact
          portion you need.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 1602845668)} />
        </div>

        <br />
        <div className="card mt-4 mb-1">
          <div className="card-body">
            <div className="text-center">
              <i className="fa fa-star color-yellow-dark fa-2x mb-3 "></i>
            </div>
            <p className="color-white">
              Do you have any favorite audio trimmer and editor apps for iPhone
              and iPad? You can share your favorite apps through the{" "}
              <Link href="/submit">
                <span className="text-white text-decoration-underline">
                  Submit Page
                </span>
              </Link>
            </p>
          </div>
          <div className="card-overlay bg-highlight opacity-95" />
          <div className="card-overlay dark-mode-tint" />
        </div>
      </div>
    </InstantArticle>
  )
}

export default BestAudioAppsArticle
